module.exports = __webpack_public_path__ + "fd638b8bb16e757eb03dbeb7d896ac17.svg";